import React, { useState } from 'react';
import Wrapper from './styles';
import { useCartContext } from '../../context/cart_context';
import { Link } from 'react-router-dom';
import { useUserContext } from '../../context/user_context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { formatPrice } from '../../utils/helpers';
import { useEffect } from 'react';
import CouponCodesPopup from '../Popups/couponCodes';
const CartContent = ({ data, isOpenCheckout }) => {
  const {
    cart,
    clearCart,
    applyCoupon,
    total_amount,
    toggleAmount,
    removeItem,
    couponDiscount,
  } = useCartContext();
  const [isOpen, setIsOpen] = useState(false);
  const [note, setNote] = useState('');
  const [giftWrap, setGiftWrap] = useState(false);
  const [promo, setPromo] = useState('');
  const { currentUser } = useUserContext();
  const [promocodes, setPromocodes]=useState([])
  const [fiilteredPromocodes, setFilteredPromocodes]=useState([])
  const [isLoading, setIsLoading]=useState(false)
  const [openCouponPopup, setOpenCouponPopup]=useState(false)
  const [selectedCoupon, setSelectedCoupon]=useState(null)

  const handleDecrease = (id) => {
    toggleAmount(id, 'dec');
  };

  const handleIncrease = (id) => {
    toggleAmount(id, 'inc');
  };

  const handleClearCart = async () => {
    let res = await clearCart();
  };
  const handleWishlistButton = async (id) => {
    let userid = currentUser.id;
    if (currentUser) {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`
      );
      const array = response?.data?.data || [];

      let isPresent = array?.includes(id);
      let options = { wishlistItem: Number(id) };
      if (!isPresent) {
        try {
          let res = await axios.put(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { id }
          );
          toast.success('Item added to wishlist');
        } catch (error) {
          console.error('Error adding item to wishlist:', error);
        }
      } else {
        try {
          const data = {
            wishlistItem: id,
          };
          let userid = currentUser.id;
          const response = await axios.delete(
            `${process.env.REACT_APP_BACKEND_HOST}/api/user/wishlistitem/${userid}`,
            { data }
          );

          toast.success('Item removed from wishlist');
        } catch (error) {
          console.error('Error deleting item from wishlist:', error);
        }
      }
    }
  };
  const handleMovetoWishlist = async (id) => {
    await removeItem(id);
    await handleWishlistButton(id);
    applyCoupon(0)
  };
  let taxAmount = 0;
  data.map((e) => (e.taxPrice += taxAmount));
 const getAllPromocodes = async () => {
    setIsLoading(true
      
    );
    let res = await axios.get(
      `${process.env.REACT_APP_BACKEND_HOST}/api/promocodes`
    );
    setPromocodes(res.data.data);
    setIsLoading(false);
  };

  useEffect(()=>{
    getAllPromocodes()

  },[])

  useEffect(()=>{
    if(selectedCoupon){
      let discountAmount=total_amount*selectedCoupon.maximumDiscount/100
      applyCoupon(discountAmount)

    }

  },[selectedCoupon])

  return (
    <div className='max-w-7xl mx-auto px-4 md:px-8 py-6'>
      <Link to='/collections'>
        <p className='underline text-sm mb-4 text-gray-600'>
          ← Continue Shopping
        </p>
      </Link>

      <h1 className='text-2xl font-bold mb-6 text-[#222222]'>Shopping Bag</h1>

      <div className='flex flex-col lg:flex-row gap-8'>
        <div className='flex-1 flex flex-col gap-6'>
          {data.map((item) => (
            <div
              key={item.id}
              className='flex flex-col sm:flex-row gap-5 rounded-lg p-4'
            >
              <div className='flex-shrink-0'>
                <img
                  src={item?.image[0]}
                  alt={item?.name}
                  className='w-32 h-32 object-cover rounded-md'
                />
              </div>

              <div className='flex-1 flex flex-col sm:ml-4 mt-3 sm:mt-0 text-left'>
                <p className='font-medium text-gray-800 text-base'>
                  {item?.name}
                </p>
                <p className='text-xs'>{item?.description}</p>
                <div className='flex-1 flex items-end'>
                  <div className='flex justify-start items-center mt-2 gap-2'>
                    <button
                      className='px-2 py-1 border rounded'
                      onClick={() => handleDecrease(item.id)}
                    >
                      -
                    </button>
                    <span className='px-2'>{item.amount}</span>
                    <button
                      className='px-2 py-1 border rounded'
                      onClick={() => handleIncrease(item.id)}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <div className='mt-3 sm:mt-0 grid grid-cols-2 gap-1 text-sm items-end text-left sm:text-right'>
                <p className='text-xs'>MRP price:</p>
                <p>{formatPrice(item.totalMetalPrice * item.amount)}</p>
                <p className='text-xs'>Tax charges:</p>
                <p>{formatPrice(Number(item.taxPrice).toFixed(2) * item.amount)}</p>
                <p className='text-xs'>GST:</p>
                <p>3%</p>
                <p className='text-xs'>Total Rs:</p>
                <p className='font-semibold'>{formatPrice(Number(item.price).toFixed(2) * item.amount)}</p>
                <p
                  className='text-[#008FAB] text-sm underline cursor-pointer mt-1'
                  onClick={() => handleMovetoWishlist(item.id)}
                >
                  Save for Later
                </p>
              </div>
            </div>
          ))}
          <div className='w-full flex justify-center items-center'>
            <button
              className='bg-[#D3A143] text-white p-2 rounded-md shadow hover:bg-[#c79338] transition'
              onClick={handleClearCart}
            >
              Clear cart
            </button>
          </div>

          <div className='border border-gray-200 rounded-lg p-4 mt-4 flex flex-col gap-3'>
            <label className='flex items-center gap-2 text-sm'>
              <input
                type='checkbox'
                checked={giftWrap}
                onChange={(e) => setGiftWrap(e.target.checked)}
              />
              Include Gift Wrapping for this order
            </label>
            <div>
              <label className='text-sm font-medium'>Add Gift Note:</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder='Enter your message...'
                className='border border-gray-300 rounded-md p-2 w-full mt-1 text-sm'
                rows='3'
              ></textarea>
            </div>
          </div>
        </div>

        <div className='w-full lg:w-1/3 border border-gray-200 rounded-lg shadow-sm p-5 h-fit bg-[#FFF9EE]'>
          <h2 className='font-semibold text-lg text-[#222222] mb-3'>
            Order Summary
          </h2>

          <div className='flex justify-between text-sm mb-1'>
            <p>Subtotal</p>
            <p>{formatPrice(Math.round(total_amount))}</p>
          </div>

          <div className='flex justify-between text-sm mb-2'>
            <p>Promo Code</p>
            <p>-Rs{couponDiscount}</p>
          </div>

          <hr className='my-2' />
          <div className='flex justify-between font-semibold text-base mb-4'>
            <p>Total</p>
            <p>{formatPrice(Math.round(total_amount) - couponDiscount)}</p>
          </div>
          <Link to={'/checkout'}>
            <button
              className='bg-[#D3A143] w-full text-white py-2 rounded-md shadow hover:bg-[#c79338] transition'
              // onClick={() => isOpenCheckout(true)}
            >
              Proceed to Checkout
            </button>
          </Link>
          <div className='mt-5'>
            <p className='font-medium text-sm mb-2'>
              Enter a Gift Card or Promo Code
            </p>
            <div className='flex gap-2'>
              <input
                type='text'
                value={selectedCoupon?.code || ""}
                onChange={(e) =>{}}
                placeholder='Enter code'
                className='border border-gray-300 rounded-md px-3 py-2 flex-1 text-sm'
              />
              <button
                className='bg-[#008FAB] text-white px-4 py-2 rounded-md text-sm'
                onClick={() => setOpenCouponPopup(true)}
              >
                Apply Coupon
              </button>
            </div>
          </div>
          {openCouponPopup && <CouponCodesPopup setOpenCouponPopup={setOpenCouponPopup} setSelectedCoupon={setSelectedCoupon} selectedCoupon={selectedCoupon}/>}
         
        </div>
      </div>
    </div>
  );
};

export default CartContent;
